function getShowEventHistory() {
  return JSON.parse(localStorage.getItem("showEventHistory")) || [];
}

function updateShowEventHistoryView() {
  const showEventHistory = getShowEventHistory();
  const container = document.querySelector("#show-events ul.list-slider-sub");
  container.innerHTML = '';
  showEventHistory.reverse().forEach((history) => {
    const template = document.querySelector("#show-event-history");
    const clone = document.importNode(template.content, true);
    clone.querySelector('a').href = history.url;
    clone.querySelector('.thum').style.backgroundImage = `url(${history.image_url})`;
    clone.querySelector('.inner').style.backgroundImage = `url(${history.image_url})`;
    clone.querySelector('.title').textContent = history.title;
    clone.querySelector('.caption').textContent = history.space_name;
    clone.querySelector('.date').textContent = history.begin_date;
    container.appendChild(clone);
  });
}

window.updateShowEventHistoryView = updateShowEventHistoryView;